import { useEffect, useRef } from "react"
import { useTranslation } from 'react-i18next';
import { FieldErrorMessage, InfoBubble } from "..";
import { MdClose } from "react-icons/md";

const InputProfile = ({ 
    formikProps,
    type,
    text, 
    name, 
    placeholder,
    maxLength,
    disabled = false,
    multiline = false,
    maxHeight = 128,
    onUnlink = null,
    unlinkLoading = null,
    integration = null,
    infoBubble = null,
    infoBubbleWidth = 256
}) => {
    const { t } = useTranslation();
    const textareaRef = useRef(null);

    const adjustTextareaHeight = () => {
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.style.height = "auto";  // Reset height
            textarea.style.height = `${5+textarea.scrollHeight}px`; // Max height of 8 rows (128px)
        }
    };

    useEffect(() => {
        if (multiline) {
            adjustTextareaHeight();
        }
    }, [formikProps.values[name], multiline]);

    return (
        <div>
            {integration ||  infoBubble ? 
                <div className="flex justify-between items-center">
                    <label
                        htmlFor={name}
                        className="mb-2 block text-sm font-medium leading-6 text-gray-900"
                    >
                        {text}
                    </label>
                    {integration &&
                        <a
                            href={integration.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-500 text-sm hover:underline"
                        >
                            {t('get-api-key', 'Obtenir la clé API')}
                        </a>
                    }
                    {infoBubble &&
                        <InfoBubble placement="top-center" text={infoBubble} width={infoBubbleWidth}/>
                    }
                </div>
                :
                <label
                    htmlFor={name}
                    className="mb-2 block text-sm font-medium leading-6 text-gray-900"
                >
                    {text}
                </label>
            }
            {multiline ? (
                <textarea
                    ref={textareaRef}
                    className="w-full bg-white p-2.5 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 resize-none overflow-y-auto disabled:bg-slate-200 disabled:text-slate-400"
                    placeholder={placeholder}
                    value={formikProps.values[name]}
                    onChange={(e) => {
                        formikProps.handleChange(e);
                        adjustTextareaHeight();
                    }}
                    onBlur={formikProps.handleBlur}
                    name={name}
                    disabled={disabled}
                    rows={2}
                    style={{ maxHeight: `${maxHeight}px` }}
                    maxLength={maxLength}
                />
            ) : (
                // Render input if multiline is false
                (integration ? 
                    <div className="relative">
                        <input
                            className="w-full bg-white p-2.5 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 h-fit overflow-hidden disabled:bg-slate-200 disabled:text-slate-400"
                            type={type}
                            placeholder={placeholder}
                            value={formikProps.values[name]}
                            onChange={formikProps.handleChange}
                            onBlur={formikProps.handleBlur}
                            name={name}
                            disabled={disabled}
                            maxLength={maxLength}
                        />

                        {integration.apiKey && (
                            <button
                            type="button"
                            className="absolute right-1 top-1/2 -translate-y-1/2 flex items-center justify-center text-black hover:text-black/60"
                            onClick={() => onUnlink(integration)}
                            disabled={unlinkLoading}
                            >
                                      <MdClose size={20} />

                            </button>
                        )}
                    </div>
                    :
                    <input
                        className="w-full bg-white p-2.5 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-black-500 focus:ring-blue-500 focus:border-blue-500 h-fit overflow-hidden disabled:bg-slate-200 disabled:text-slate-400"
                        type={type}
                        placeholder={placeholder}
                        value={formikProps.values[name]}
                        onChange={formikProps.handleChange}
                        onBlur={formikProps.handleBlur}
                        name={name}
                        disabled={disabled}
                        maxLength={maxLength}
                    />
                )
            )}
            <div className="flex justify-between items-center text-xs">
                <FieldErrorMessage name={name} />
                {maxLength && (
                    <div className="text-gray-500">
                        {formikProps.values[name]?.length} / {maxLength}
                    </div>
                )}
            </div>
        </div>
    )
}

export default InputProfile;